// extracted by mini-css-extract-plugin
export default {"offset_header":"social-section-core-SectionModalHeader__offset_header--1I0Hx"};